import { Modal } from "antd";

const ShowVideoModal = ({ show, hide, onOk, data }) => {
    return (
      <Modal
        width={350}
        open={show}
        onCancel={hide}
        centered
        className="tab_modal deleteWarningModal main-new-video-modal-ikj"
        footer={[
          <button key="back" onClick={hide} className="ant-btn ant-btn-default">
            Back
          </button>,
        ]}
      >
        <div style={{ textAlign: "center" }}>
          <video className="video-view" width={400} controls src={data} />
        </div>
      </Modal>
    );
  };


  export default ShowVideoModal;